<action class="w-12 button p-r-0-s p-l-0-s"
        [class.is-disabled]="isDisabled"
        [status]="status"
        (click)="submit()"
        cy-basketAddButton>
    {{ buttonCopy }}
</action>
<result class="block"
        [status]="status"></result>
